module.exports = __webpack_public_path__ + "img/bg_avatar_female_60.313dd009.png";